import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "../../assets/styles/retreatlinks/Vedicmantra.module.css";
import BooksSection from "components/MyBooks/Bookssection";
import HowToReach from "components/Homepage/HowToReach";
const ENV_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

const API = `${ENV_API_BASE_URL}/api/vedic-mantra`;

const resolveAssetUrl = (value) => {
  if (!value || typeof value !== "string") return "";
  if (/^https?:\/\//.test(value)) return value;
  if (value.startsWith("/uploads/")) return `${ENV_API_BASE_URL}${value}`;
  return `${ENV_API_BASE_URL}/uploads/${value.replace(/^\/+/, "")}`;
};

const resolveEmbedUrl = (value) => {
  if (!value || typeof value !== "string") return "";
  const raw = value.trim();
  if (!raw) return "";

  // If already an embed url, keep it.
  if (raw.includes("youtube.com/embed/")) return raw;

  try {
    const url = new URL(raw);
    const host = url.hostname.replace(/^www\./, "");

    // youtube.com/watch?v=VIDEO_ID
    if (host === "youtube.com" || host === "m.youtube.com") {
      const v = url.searchParams.get("v");
      if (v) return `https://www.youtube.com/embed/${v}`;

      // youtube.com/shorts/VIDEO_ID
      const shortsMatch = url.pathname.match(/^\/shorts\/([^/?#]+)/);
      if (shortsMatch) return `https://www.youtube.com/embed/${shortsMatch[1]}`;
    }

    // youtu.be/VIDEO_ID
    if (host === "youtu.be") {
      const id = url.pathname.replace(/^\/+/, "").split("/")[0];
      if (id) return `https://www.youtube.com/embed/${id}`;
    }

    // fallback for non-youtube or unknown formats: try as-is
    return raw;
  } catch {
    return raw;
  }
};

const VedicMantra = () => {

  const [data, setData] = useState(null);
  const [activeMantra, setActiveMantra] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await axios.get(API);

      if (res.data.data.length > 0) {
        setData(res.data.data[0]); // first document
      }

    } catch (err) {
      console.log("API Error", err);
    }
  };

  if (!data) return <div>Loading...</div>;

  return (
    <div className={styles.container}>

      {/* HERO */}

      {/* <section className={`${styles.hero} ${isVisible ? styles.visible : ""}`}>
        <div
          className={styles.heroOverlay}
          style={{
            backgroundImage: data.heroImage ? `url(${resolveAssetUrl(data.heroImage)})` : undefined,
          }}
        />
      </section> */}
      <img src={`${resolveAssetUrl(data.heroImage)}`} alt="Vedic Mantra" className="img-fluid" />


      {/* WHAT IS MANTRA */}

      <section className={styles.whatSection}>
        <div className={styles.contentGrid}>

          <div className={styles.textContent}>
            <h2 className={styles.sectionTitle}>
              {data.mantraTitle}
            </h2>

            <p className={styles.paragraph}>
              {data.mantraDescription}
            </p>

            <p className={styles.paragraph}>
              {data.mantraDescription2}
              <span className={styles.highlight}>
                {data.mantraHighlight}
              </span>
            </p>

          </div>

          <div className={styles.imageContent}>
            <div className={styles.mantraImage}>
              <img src={resolveAssetUrl(data.mantraImage)} alt="Mantra" />
            </div>
          </div>

        </div>
      </section>


      {/* WHY SECTION */}

      <section className={styles.whySection}>
        <div className={styles.contentGrid}>

          <div className={styles.omCard}>
            <div className={styles.omGlow}>
              <span className={styles.omLarge}>ॐ</span>
            </div>

            <div className={styles.sanskritText}>
              {data.omSanskritText?.split("\n").map((line, i) => (
                <p key={i}>{line}</p>
              ))}
            </div>

          </div>

          <div className={styles.textContent}>

            <h2 className={styles.sectionTitle}>
              {data.whyTitle}
            </h2>

            <p className={styles.paragraph}>
              {data.whyDescription}
            </p>

            <div className={styles.benefitsList}>

              {data.whyBenefitItems?.map((item, index) => (

                <div key={index} className={styles.benefitItem}>
                  <strong>{item.title}:</strong> {item.description}
                </div>

              ))}

            </div>

          </div>

        </div>
      </section>


      <BooksSection />


      {/* TYPES */}

      <section className={styles.typesSection}>

        <h2 className={styles.sectionTitle}>
          {data.typesTitle}
        </h2>

        <p className={styles.typesParagraph}>{data.typesParagraph1}</p>
        <p className={styles.typesParagraph}>{data.typesParagraph2}</p>
        <p className={styles.typesParagraph}>{data.typesParagraph3}</p>
        <p className={styles.typesParagraph}>{data.typesParagraph4}</p>


        <div className={styles.mantraGrid}>

          {data.mantraTypes?.map((mantra, index) => (

            <div
              key={index}
              className={styles.mantraCard}
              onClick={() =>
                setActiveMantra(activeMantra === index ? null : index)
              }
            >

              <h3 className={styles.mantraName}>
                {mantra.name}
              </h3>

              {activeMantra === index && (

                <div className={styles.mantraDetails}>

                  <p className={styles.sanskrit}>
                    {mantra.sanskrit}
                  </p>

                  <p className={styles.transliteration}>
                    {mantra.transliteration}
                  </p>

                </div>

              )}

            </div>

          ))}

        </div>

      </section>


      {/* GAYATRI */}

      <section className={styles.gayatriSection}>

        <div className={styles.videoContainer}>

          <iframe
            width="100%"
            height="300"
            src={resolveEmbedUrl(data.gayatriVideoUrl)}
            title="Gayatri"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />

        </div>

        <div className={styles.gayatriContent}>

          <h3 className={styles.gayatriTitle}>
            {data.gayatriTitle}
          </h3>

          <ul className={styles.gayatriList}>

            {data.gayatriLines?.map((line, index) => (
              <li key={index}>{line}</li>
            ))}

          </ul>

          <p className={styles.gayatriDesc}>
            {data.gayatriDesc}
          </p>

          <p className={styles.gayatriSanskrit}>
            {data.gayatriSanskrit}
          </p>

          <p className={styles.gayatriTranslation}>
            {data.gayatriTranslation}
          </p>

          <div className={styles.mantraCategories}>

            {data.mantraCategories?.map((cat, index) => (

              <div key={index} className={styles.category}>
                {cat}
              </div>

            ))}

          </div>

          <button className={styles.bookButton}>
            {data.bookButtonText}
          </button>

        </div>

      </section>


      {/* BENEFITS */}

      <section className={styles.benefitsSection}>

        <h2 className={styles.sectionTitle}>
          {data.benefitsTitle}
        </h2>

        <p className={styles.benefitsIntro}>
          {data.benefitsIntro}
        </p>

        <div className={styles.benefitsGrid}>

          <div className={styles.benefitsImage}>
            <img src={resolveAssetUrl(data.benefitsImage)} alt="Benefits" />
          </div>

          <div className={styles.benefitsContent}>

            {data.benefits?.map((benefit, index) => (

              <div key={index} className={styles.benefitCard}>

                <h3 className={styles.benefitTitle}>
                  {benefit.title}
                </h3>

                <p className={styles.benefitDesc}>
                  {benefit.description}
                </p>

              </div>

            ))}

          </div>

        </div>

      </section>


      <HowToReach />

    </div>
  );
};

export default VedicMantra;